"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var column_info_1 = require("../../model/column-info");
var operators_1 = require("rxjs/operators");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var BaseTableComponent = /** @class */ (function () {
    function BaseTableComponent(kbService, formResolutionService) {
        this.kbService = kbService;
        this.formResolutionService = formResolutionService;
        this.colSystemNames = [];
        this.entityNavigationSubject = new Subject_1.Subject();
        this.afterTableActionSubject = new Subject_1.Subject();
        this.destroy$ = new Subject_1.Subject();
    }
    BaseTableComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    BaseTableComponent.prototype.getColumnData = function () {
        var _this = this;
        var metaFieldObservables$ = [];
        var categoryNames = new Set().add(this.subEntityCategoryId);
        this.colSystemNames.forEach(function (colSystemName) {
            if (colSystemName.compoundName) {
                categoryNames.add(colSystemName.compoundName);
            }
        });
        categoryNames.forEach(function (category) {
            metaFieldObservables$.push(_this.kbService.getMetaFields(category));
        });
        return Observable_1.Observable.zip.apply(Observable_1.Observable, metaFieldObservables$).pipe(operators_1.concatMap(function (allMetaFields) { return _this.kbService.getNameMetaFieldIds(_this.mainEntityCategoryName).map(function (nameMetaFields) { return ({ allMetaFields: allMetaFields, mainEntityNameMetaFields: nameMetaFields }); }); }), operators_1.map(function (subEntity) {
            var columnData = [];
            subEntity.allMetaFields.forEach(function (categoryMetaFields) {
                categoryMetaFields.forEach(function (metaField) {
                    _this.colSystemNames.forEach(function (colData) {
                        if ((metaField.getSystemName() === colData.systemName) &&
                            (metaField.getMetaFieldId().getMetaCategoryId().getSystemName() === colData.compoundName)) {
                            columnData.push(new column_info_1.ColumnInfo(colData.parentFieldName, metaField, _this.isSelectedMainEntityNameField(colData, subEntity.mainEntityNameMetaFields, _this.mainEntityFieldName)));
                        }
                    });
                });
            });
            // Sort column fields
            return _this.colSystemNames.map(function (colSystemName) {
                return columnData.find(function (column) {
                    return (column.field.getSystemName() === colSystemName.systemName) &&
                        (column.field.getMetaFieldId().getMetaCategoryId().getSystemName() === colSystemName.compoundName) &&
                        (column.parentFieldName === colSystemName.parentFieldName);
                });
            });
        }));
    };
    BaseTableComponent.prototype.subscribeToFormActions = function () {
        var _this = this;
        this.actionNotifier
            .takeUntil(this.destroy$)
            .subscribe(function (action) {
            if (_this.isNavigatedToEntity) {
                _this.isNavigatedToEntity = false;
                if (action.key === idm_dynamic_forms_ui_1.ActionNotifierKey.DRAWER_SAVE_ACTION) {
                    var subEntities = _this.entity.getProperty(_this.subEntityFieldId).value;
                    var drawerEntity_1 = action.data.getData();
                    subEntities.map(function (subEntity) {
                        var entity = subEntity.getProperty(_this.mainEntityFieldName).value;
                        if (entity.getInstanceId() === drawerEntity_1.getInstanceId()) {
                            subEntity.getProperty(_this.mainEntityFieldName).value = drawerEntity_1;
                        }
                    });
                    _this.afterTableActionSubject.next(null);
                }
            }
        });
    };
    BaseTableComponent.prototype.subscribeToEntityNavigation = function () {
        var _this = this;
        this.entityNavigationSubject
            .takeUntil(this.destroy$)
            .subscribe(function (rowSubEntity) { return _this.navigateToExistingEntity(rowSubEntity); });
    };
    BaseTableComponent.prototype.subscribeToTableActions = function () {
        var _this = this;
        this.afterTableActionSubject
            .takeUntil(this.destroy$)
            .subscribe(function () { return _this.updateTableRows(); });
    };
    BaseTableComponent.prototype.navigateToExistingEntity = function (rowSubEntity) {
        var _this = this;
        this.isNavigatedToEntity = true;
        var mainEntity = rowSubEntity.getProperty(this.mainEntityFieldName).value;
        var entityId = mainEntity.getInstanceId();
        var entityType;
        var entitySubType;
        if (this.mainEntityTypeConfigs) {
            entityType = this.mainEntityTypeConfigs.type ? mainEntity.getProperty(this.mainEntityTypeConfigs.type.field).value : null;
            entitySubType = this.mainEntityTypeConfigs.subType ? mainEntity.getProperty(this.mainEntityTypeConfigs.subType.field).value : null;
        }
        this.formResolutionService.getFormProperties(this.mainEntityCategoryName, entityType, entitySubType)
            .pipe(operators_1.takeUntil(this.destroy$), operators_1.take(1))
            .subscribe(function (formProperties) {
            _this.form.actions.editEntityPopup(_this.isReadonly ? formProperties.viewFormName : formProperties.editFormName, _this.mainEntityCategoryName, _this.isReadonly ? formProperties.viewFormId : formProperties.editFormId, entityId);
        });
    };
    BaseTableComponent.prototype.isSelectedMainEntityNameField = function (colData, mainEntityNameMetaFields, mainEntityFieldName) {
        return (colData.parentFieldName === mainEntityFieldName)
            && mainEntityNameMetaFields.some(function (nameMetaField) { return nameMetaField.getSystemName() === colData.systemName; });
    };
    BaseTableComponent.prototype.updateTableRows = function (subEntityId) {
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], BaseTableComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_dynamic_forms_ui_1.DynamicFormComponent)
    ], BaseTableComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], BaseTableComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], BaseTableComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BaseTableComponent.prototype, "categoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BaseTableComponent.prototype, "subEntityCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BaseTableComponent.prototype, "subEntityFieldId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], BaseTableComponent.prototype, "colSystemNames", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BaseTableComponent.prototype, "mainEntityCategoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BaseTableComponent.prototype, "mainEntityFieldName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], BaseTableComponent.prototype, "mainEntityTypeConfigs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], BaseTableComponent.prototype, "customTableActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BaseTableComponent.prototype, "idPrefix", void 0);
    return BaseTableComponent;
}());
exports.BaseTableComponent = BaseTableComponent;
//# sourceMappingURL=base-table.component.js.map